import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/lib/auth';
import { supabase } from '@/lib/supabase';

export const CURRENT_USER_MEMBERSHIP_TITLE_QUERY_KEY = 'current-user-membership-title' as const;

export const currentUserMembershipTitleQueryKey = (
  userId: string | null,
  clinicId: string | null,
) => [CURRENT_USER_MEMBERSHIP_TITLE_QUERY_KEY, userId, clinicId] as const;

/** Job title (stilling) from clinic_memberships.title for the signed-in user in a clinic. */
export function useCurrentUserMembershipTitle(clinicId: string | null | undefined) {
  const { user } = useAuth();
  const userId = user?.id ?? null;
  const clinic = clinicId ?? null;

  return useQuery({
    queryKey: currentUserMembershipTitleQueryKey(userId, clinic),
    enabled: Boolean(userId && clinic),
    queryFn: async (): Promise<string | null> => {
      const { data, error } = await supabase
        .from('clinic_memberships')
        .select('title')
        .eq('user_id', userId!)
        .eq('clinic_id', clinic!)
        .eq('status', 'active')
        .maybeSingle();
      if (error) throw error;
      return data?.title ?? null;
    },
    staleTime: 30_000,
  });
}
